import React from 'react';
import type { MonthYearSelectorProps } from '../../../types/dateTypes';
import { dateUtils } from '../../../utils/dateUtils';

const MonthYearSelector: React.FC<MonthYearSelectorProps> = ({
  currentMonth,
  currentYear,
  onMonthChange,
  onYearChange,
  minYear = 1900,
  maxYear = 2100
}) => {
  const monthNames = dateUtils.getShortMonthNames();
  
  // Generate year options
  const yearOptions = [];
  for (let year = minYear; year <= maxYear; year++) {
    yearOptions.push(year);
  }

  const handlePrevMonth = () => {
    if (currentMonth === 0) {
      onMonthChange(11);
      onYearChange(currentYear - 1);
    } else {
      onMonthChange(currentMonth - 1);
    }
  };

  const handleNextMonth = () => {
    if (currentMonth === 11) {
      onMonthChange(0);
      onYearChange(currentYear + 1);
    } else {
      onMonthChange(currentMonth + 1);
    }
  };

  return (
    <div className="month-year-selector">
      <button
        type="button"
        className="nav-button prev-button"
        onClick={handlePrevMonth}
        aria-label="Previous month"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="15,18 9,12 15,6"></polyline>
        </svg>
      </button>

      <div className="selectors">
        <select
          className="month-selector"
          value={currentMonth}
          onChange={(e) => onMonthChange(parseInt(e.target.value))}
          aria-label="Select month"
        >
          {monthNames.map((month, index) => (
            <option key={index} value={index}>
              {month}
            </option>
          ))}
        </select>

        <select
          className="year-selector"
          value={currentYear}
          onChange={(e) => onYearChange(parseInt(e.target.value))}
          aria-label="Select year"
        >
          {yearOptions.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>

      <button
        type="button"
        className="nav-button next-button"
        onClick={handleNextMonth}
        aria-label="Next month"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="9,18 15,12 9,6"></polyline>
        </svg>
      </button>
    </div>
  );
};

export default MonthYearSelector;